/**
 * Ownership of the elongation preview mesh (the blue stretched clone).
 *
 * The preview is created imperatively by `ElongationHandler` but torn down from
 * two places — the handler's effects and the apply command in
 * `useElongationStore` — so the removal rules live here instead of being
 * duplicated (and drifting) at each call site. `purgeElongationPreviews` is the
 * backstop: whatever path lost track of a clone, nothing named
 * `ElongationPreview` survives an apply.
 */

export const ELONGATION_PREVIEW_NAME = 'ElongationPreview';

/** Detach a preview mesh from the scene graph and release its GPU resources. */
export function disposePreviewObject(mesh) {
  if (!mesh) return;
  mesh.parent?.remove(mesh);
  mesh.geometry?.dispose?.();
  mesh.material?.dispose?.();
}

/**
 * Remove every elongation preview left in the scene.
 *
 * @param {THREE.Scene|null} scene
 * @param {THREE.Object3D|null} keep — preview that is still in use, if any.
 */
export function purgeElongationPreviews(scene, keep = null) {
  if (!scene) return;
  const stale = [];
  scene.traverse((o) => {
    if (o !== keep && o.isMesh && o.name === ELONGATION_PREVIEW_NAME) stale.push(o);
  });
  stale.forEach(disposePreviewObject);
}
